import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { EmployeeService } from '../employee.service';
import { EmpdeleteDialogComponent } from '../empdelete-dialog/empdelete-dialog.component';
import { Md5 } from 'ts-md5';

@Component({
  selector: 'app-employee-login',
  templateUrl: './employee-login.component.html',
  styleUrls: ['./employee-login.component.scss']
})
export class EmployeeLoginComponent implements OnInit {

  errorDescription: string;

  loginform!: FormGroup;
  showpassword: boolean = false;
  logindetails: any;
  isFormInvalid: boolean = false;
  invalidpassword: boolean = false;
  loginserver: boolean = false;
  deactivated: boolean = false;
  invalidpayroll: boolean = false;
  constructor(private fb: FormBuilder, private dialog: MatDialog, private spinner: NgxSpinnerService, private login: EmployeeService) { }

  ngOnInit(): void {
    this.loginform = this.fb.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  toggleshow() {
    this.showpassword = !this.showpassword;
  }

  submit() {
    if (this.loginform.valid) {
      this.isFormInvalid = true;
      this.invalidpassword = false;
      const pass = {
        password: this.loginform.value.password
      }
      const passwordmd5 = Md5.hashStr(pass.password).toString();
      // const payload1 = 'username=' + this.loginform.value.userName + '&password=' + passwordmd5 + '&grant_type=password&app_name=SCEmployee+APP&deviceId=1b07bcb93986ef3c&fcm_id=test123';
      const payload1 = {
        payrollId: this.loginform.value.userName,
        password: passwordmd5
      }
      this.spinner.show();
      this.login.postlogin(payload1).subscribe(
        {
          next: (res: any) => {
            this.logindetails = res;
            console.log('logindetails', this.logindetails);
            this.spinner.hide();
            this.isFormInvalid = false;
            this.loginform.reset();
            console.log("login", this.logindetails);
            localStorage.setItem('token', this.logindetails.map.accessToken);
            if (this.logindetails.map.accessKey === true) {
              this.deactivated = false;
              this. errorDescription='';
              this.dialog.open(EmpdeleteDialogComponent, {
                disableClose: true,
              });
            }
            else {
              //change the deactivated true //
              this.deactivated = true;
              this.invalidpassword = false;
            }
          }, error: (error: any) => {
            console.log("error_description", error.error.error_description);
            this.errorDescription=error.error.error_description;
            this.loginform.reset();
            this.deactivated = false;
            this.isFormInvalid = false;
            this.spinner.hide();
            if (error.error_description === 400) {
              console.error('Unauthorized access. Please check your credentials.');
              this.loginform.reset();
            } else if (error.status === 500) {
              this.loginserver = true;
              this.invalidpassword = false;
              this.deactivated = false;
              console.error('Internal Server Error');
              this.loginform.reset();
            } 
          },
          complete: () => {
            console.log('completed!');
          }
        }
      );
    } else {
      this.isFormInvalid = true;
      this.invalidpassword = false;
    }
  }

}
